import request from '@/utils/request'


// 查询短剧列表
export function listVideo(query) {
  return request({
    url: '/video/videos/list',
    method: 'get',
    params: query
  })
}

// 查询短剧分页
export function pageVideo(query) {
  return request({
    url: '/video/videos/page',
    method: 'get',
    params: query
  })
}

export function listSelect(query) {
  return request({
    url: '/video/videos/listSelect',
    method: 'get',
    params: query
  })
}

// 查询短剧详细
export function getVideo(data) {
  return request({
    url: '/video/videos/detail',
    method: 'get',
    params: data
  })
}

// 新增短剧
export function addVideo(data) {
  return request({
    url: '/video/videos/add',
    method: 'post',
    data: data
  })
}

// 修改短剧
export function updateVideo(data) {
  return request({
    url: '/video/videos/edit',
    method: 'post',
    data: data
  })
}

// 删除短剧
export function delVideo(data) {
  return request({
    url: '/video/videos/delete',
    method: 'post',
    data: data
  })
}

export function changeIsOpen(data) {
  return request({
    url: '/video/videos/changeIsOpen',
    method: 'post',
    data: data
  })
}


export function editSort(data) {
  return request({
    url: '/video/videos/editSort',
    method: 'post',
    data: data
  })
}


export function editType(data) {
  return request({
    url: '/video/videos/editType',
    method: 'post',
    data: data
  })
}


export function editTrendingSort(data) {
  return request({
    url: '/video/videos/editTrendingSort',
    method: 'post',
    data: data
  })
}

export function getPlaylist() {
  return request({
    url: '/video/videos/getPlaylist',
    method: 'get'
  });
}

export function selectAllPlaylist() {
  return request({
    url: '/video/videos/selectAllPlaylist',
    method: 'get'
  });
}

// 复制片单
export function copyPlaylist(data, params) {
  return request({
    url: '/video/videos/copyPlaylist',
    method: 'post',
    data,
    params
  });
}

// 新增片单
export function addCustomizeForm(data) {
  return request({
    url: '/video/videos/addCustomizeForm',
    method: 'post',
    data
  });
}

// 修改片单
export function editCustomizeForm(data) {
  return request({
    url: '/video/videos/editCustomizeForm',
    method: 'post',
    data
  });
}

// 删除片单
export function delCustomizeForm(data) {
  return request({
    url: '/video/videos/delCustomizeForm',
    method: 'post',
    data
  });
}

// 查询片单
export function selectCustomizeForm(query) {
  return request({
    url: '/video/videos/selectCustomizeForm',
    method: 'get',
    params: query
  });
}

// 查询片单详情
export function getCustomizeFormDetail(query) {
  return request({
    url: '/video/videos/getCustomizeFormDetail',
    method: 'get',
    params: query
  });
}


export function changePlaylistIsOpen(data) {
  return request({
    url: '/video/videos/changePlaylistIsOpen',
    method: 'post',
    data: data
  })
}

// 新增片单短剧
export function addPlaylistVideo(data) {
  return request({
    url: '/video/videos/addPlaylistVideo',
    method: 'post',
    data
  });
}

// 修改片单短剧
export function editPlaylistVideo(data) {
  return request({
    url: '/video/videos/editPlaylistVideo',
    method: 'post',
    data
  });
}

// 删除片单短剧
export function delPlaylistVideo(data) {
  return request({
    url: '/video/videos/delPlaylistVideo',
    method: 'post',
    data
  });
}

// 查询片单短剧
export function selectPlaylistVideo(query) {
  return request({
    url: '/video/videos/selectPlaylistVideo',
    method: 'get',
    params: query
  });
}


// 短剧坑位
export function pitPositionList(query) {
  return request({
    url: '/video/videos/pitPositionList',
    method: 'get',
    params: query
  });
}

export function editPitPosition(data) {
  return request({
    url: '/video/videos/editPitPosition',
    method: 'post',
    data: data
  });
}

export function pitPositionDetail(query) {
  return request({
    url: '/video/videos/pitPositionDetail',
    method: 'get',
    params: query
  });
}

// 新增换脸素材
export function addFaceSwap(data) {
  return request({
    url: '/video/videos/addFaceSwap',
    method: 'post',
    data
  })
}

// 更新换脸素材
export function updateFaceSwap(data) {
  return request({
    url: '/video/videos/updateFaceSwap',
    method: 'post',
    data
  })
}

export function updateFaceSwapTag(data) {
  return request({
    url: '/video/videos/updateTag',
    method: 'post',
    data
  })
}

export function delFaceSwap(data) {
  return request({
    url: '/video/videos/delFaceSwap',
    method: 'post',
    data
  })
}


// 获取换脸素材详情
export function faceSwapList(query) {
  return request({
    url: '/video/videos/faceSwapList',
    method: 'get',
    params: query
  })
}

// 导入用户
export function importData (data) {
  return request({
    url: '/video/videos/importData',
    method: 'post',
    data: data
  })
}

export function faceSwapTaskList(query) {
  return request({
    url: '/video/videos/faceSwapTaskList',
    method: 'get',
    params: query
  })
}